<script>
import { mapState } from 'vuex'

export default {
  computed: {
    ...mapState('auth', {
      permissoes: state => state.usuarioLogado.permissoes,
      cargo: state => state.usuarioLogado.perfilSelecionado.codigo
    })
  },

  methods: {
    hasPermissao (codigo) {
      if (this.permissoes && this.permissoes.length > 0) {
        return !!this.permissoes.find(permissao => permissao.codigo === codigo)
      }
      return false
    },
    isChefeSetor () {
      return this.cargo.includes('CHEFE')
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/utils/PermissaoHelper.vue